import { DataProvider, getJwtData, clearJwtData } from "./../../providers";
import React, { Component } from "react";
import { CircularProgress } from "@material-ui/core";
import { GET_ONE, WithPermissions, Title } from "react-admin";
import { CartoneroDashboard } from "../DashboardCartoneros/Cartonero";
import { CoordinadorDashboard } from "./Coordinador.js";
import { AdminDashboard } from "./Admin.js";
import { PesadorDashboard } from "./Pesador.js";
import { EnfardadorDashboard } from "./Enfardador.js";
import { AuditorDashboard } from "./Auditor.js";
import { Redirect } from "react-router-dom";

const styles = {
  icon: {
    fontSize: "40px",
    color: "#4dabf5",
    marginBottom: "-12px"
  },
  grid: {
    flexGrow: 1,
    fontFamily: ["Roboto", "Helvenita", "Arial", "sans-serif"].join(",")
  },
  cardContent: {
    user: {
      paddingTop: "22px",
      fontWeight: "bold",
      fontSize: "20px"
    },
    prop: {
      fontWeight: "normal"
    },
    value: {
      fontWeight: "lighter"
    },
    divider: {}
  },
  pesajes: {
    title: {
      fontSize: "16px",
      fontWeight: "bold",
      paddingTop: "8px"
    },
    icon: {
      withGoal: {
        fontSize: "1.8rem",
        padding: "5px",
        color: "green"
      },
      underGoal: {
        fontSize: "1.8rem",
        padding: "5px",
        color: "black"
      }
    },
    subtotals: {
      fontWeight: "bold"
    }
  },
  listValue: {
    color: "#666"
  },
  circularWeightBar: {
    maxWidth: "250px",
    marginLeft: "20px"
  }
};

class DashboardComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {},
      permissions: null,
      isLogged: true
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.permissions !== this.props.permissions) {
      //not working with shouldComponentUpdate
      this.setState({ permissions: nextProps.permissions });
      if (this.hasPermissions(nextProps.permissions)) {
        const jwt = getJwtData();
        return DataProvider(GET_ONE, "me", { id: jwt.usuariosId })
          .then(response => {
            if (response.data.pesajes) {
              response.data.pesajes.progreso = Math.floor(
                (response.data.pesajes.acumuladoMensual * 100) / 2000
              );
            }
            this.setState({ user: response.data });
          })
          .catch(error => {
            if (error.name === "NotAuthenticated") {
              clearJwtData();
              this.setState({ isLogged: false });
            }
          });
      }
    }
  }

  /** Validation Methods */

  hasPermissions(userPermissions) {
    const permissions = [
      "admin",
      "coordinador",
      "cartonero",
      "pesador",
      "auditor",
      "enfardador"
    ];
    return permissions.indexOf(userPermissions) > -1;
  }

  /** Render Methods */

  renderTitle() {
    const { permissions } = this.state;
    const { user } = this.state;
    if (permissions === "admin") {
      return <Title title="Tablero de Administración" />;
    } else if (permissions === "pesador") {
      return <Title title="Tablero de control" />;
    } else if (permissions === "cartonero") {
      return <Title title={user.nombre} />;
    } else {
      return <Title title="Tablero de Control" />;
    }
  }

  renderCartoneroCard(user) {
    return <CartoneroDashboard user={user} />;
  }

  renderCoordinadorCard(user) {
    return <CoordinadorDashboard user={user} styles={styles} />;
  }

  renderAdminCard(user) {
    return <AdminDashboard user={user} styles={styles} />;
  }

  renderPesadorCard(user) {
    return <PesadorDashboard user={user} styles={styles} />;
  }

  renderEnfardadorCard(user) {
    return <EnfardadorDashboard user={user} styles={styles} />;
  }

  renderAuditorCard(user) {
    return <AuditorDashboard user={user} styles={styles} />;
  }

  renderCard(role, user) {
    if (!role || !user) return null;
    const content = {
      cartonero: () => this.renderCartoneroCard(user),
      coordinador: () => this.renderCoordinadorCard(user),
      admin: () => this.renderAdminCard(user),
      pesador: () => this.renderPesadorCard(user),
      auditor: () => this.renderAuditorCard(user),
      enfardador: () => this.renderEnfardadorCard(user)
    };
    return content[role]();
  }

  renderIfIsLogged() {
    const { permissions, user } = this.state;
    if (permissions && user && user.nombre && user.dni) {
      return (
        <div>
          {this.renderTitle(permissions, user)}
          {this.renderCard(permissions, user)}
        </div>
      );
    } else {
      return (
        <div style={{ textAlign: "center" }}>
          <Title title="Cargando..." />
          <CircularProgress />
        </div>
      );
    }
  }

  render() {
    const { isLogged } = this.state;
    if (isLogged) {
      return this.renderIfIsLogged();
    } else {
      return <Redirect to="/login" />;
    }
  }
}

export const Dashboard = () => {
  return (
    <WithPermissions render={props => <DashboardComponent {...props} />} />
  );
};



// WEBPACK FOOTER //
// ./src/components/dashboard/Dashboard.js